import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import { PaginatedRequest } from '../../../types/api';
import {
  CreateUserGiftRequest,
  FetchGiftTypesResponse,
  FetchUserGiftsResponse,
  UpdateUserGiftRequest,
  UserGift,
} from '../../../types/userGift';
import { toQueryParams } from '../../../utils/request';

export const userGiftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchUserGifts: builder.query<FetchUserGiftsResponse, PaginatedRequest>({
      query: (data) => ({
        url: `/admin/user-gifts?${toQueryParams(data)}`,
        method: 'GET',
      }),
      providesTags: (res) => [
        ...(res?.items || []).map(({ id }) => ({ type: ApiTagType.UserGift as const, id })),
        { type: ApiTagType.UserGift, id: 'LIST' },
      ],
    }),
    fetchGiftTypes: builder.query<FetchGiftTypesResponse, void>({
      query: () => ({
        url: '/admin/user-gifts/types',
        method: 'GET',
      }),
    }),
    createUserGift: builder.mutation<UserGift, CreateUserGiftRequest>({
      query: (data) => ({
        url: '/admin/user-gifts',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: ApiTagType.UserGift, id: 'LIST' }],
    }),
    updateUserGift: builder.mutation<UserGift, UpdateUserGiftRequest>({
      query: ({ id, ...data }) => ({
        url: `/admin/user-gifts/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (res, error, req) => [
        { type: ApiTagType.UserGift, id: req.id },
        { type: ApiTagType.UserGift, id: 'LIST' },
      ],
    }),
  }),
});

export const { useFetchUserGiftsQuery, useFetchGiftTypesQuery, useCreateUserGiftMutation, useUpdateUserGiftMutation } =
  userGiftApiSlice;
